module.exports = __webpack_public_path__ + "img/dailijiameng.177beae2.png";